import { oneDayInHours } from "./oneDayInHours";
import { oneHourInMinutes } from "./oneHourInMinutes";

export const oneDayInMinutes = oneHourInMinutes * oneDayInHours;
